export default __webpack_public_path__ + "static/media/opensea.96fe8302.svg";